import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="lg:w-1/2 relative bg-background-100 flex items-end min-h-[320px] lg:min-h-[560px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20smartphone%20displaying%20abstract%20warm%20toned%20entertainment%20content%2C%20dark%20crimson%20and%20amber%20UI%20aesthetic%2C%20soft%20glow%2C%20editorial%20style%2C%20minimal%20design%2C%20no%20text&width=800&height=1000&seq=app-visual-51cg-007&orientation=portrait"
            alt="手机端吃瓜入口"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
          <div className="relative z-10 p-8 md:p-12 lg:p-16 w-full">
            <span className="text-white/60 text-xs md:text-sm font-medium tracking-widest uppercase mb-3 block">{appData.tag}</span>
            <h2 className="text-white font-heading font-bold text-3xl md:text-4xl lg:text-5xl leading-tight">
              {appData.titleLine1}
              <br />
              {appData.titleLine2}
              <br />
              {appData.titleLine3}
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-12 py-12 lg:py-0">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl text-center leading-tight mb-1">
            {appData.mainTitle}
          </h2>
          <h3 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl text-center leading-tight mb-6">
            {appData.mainTitle2}
          </h3>
          <div className="space-y-4 max-w-md w-full mb-6">
            {appData.features.map((feat, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-primary-500 text-xs"></i>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed">{feat}</p>
              </div>
            ))}
          </div>
          <a
            href="#app"
            className="inline-flex items-center gap-2 bg-secondary-600 hover:bg-secondary-700 text-white px-6 py-3 rounded-full text-sm md:text-base font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            {appData.cta.label}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}